import { HttpEvent, HttpEventType } from '@angular/common/http';
import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { saveAs } from 'file-saver';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { EMPTY, Observable, Subject, Subscription, catchError, concatMap, finalize, from, map, mergeMap, takeUntil, tap, toArray } from 'rxjs';
import { CommentObject } from '../models/comment.model';
import { MFilesItem } from '../models/mfiles-item.model';
import { Property } from '../models/property.model';
import { SharesLink } from '../models/shares-link.model';
import { AuthService } from '../services/auth.service';
import { ConfigurationService } from '../services/configuration.service';
import { LayoutService } from '../services/layout.service';
import { MFilesService } from '../services/mfiles.service';
import { PageService } from '../services/page.service';

@Component({
	selector: 'app-file-share-listing',
	templateUrl: './file-share-listing.component.html',
	styleUrls: ['./file-share-listing.component.css']
})
export class FileShareListingComponent implements OnInit, OnDestroy {
	@ViewChild('fileShareCreateModal') private fileShareCreateModal: TemplateRef<any>;
	@ViewChild('fileShareDeleteModal') private fileShareDeleteModal: TemplateRef<any>;
	@ViewChild('viewerModal') private viewerModal: TemplateRef<any>;
	@ViewChild('docShareModalModal') private docShareModalModal: TemplateRef<any>;
	@ViewChild('advancedSearchModal') private advancedSearchModal: TemplateRef<any>;
	@ViewChild('downloadProgressModal') private downloadProgressModal: TemplateRef<any>;
	@ViewChild('uploadProgressModal') private uploadProgressModal: TemplateRef<any>;

	modalRef: BsModalRef;
	viewerModalRef: BsModalRef;
	downloadProgressModalRef: BsModalRef;
	uploadProgressModalRef: BsModalRef;

	canCreate = false;
	loadingCanCreate = true;
	loading = true;
	loadingIndex = -1;
	loadingComments = false;
	loadingProperties = false;
	loadingRightPanel = false;

	rightContainerExpanded = false;

	fields = [];
	formData = {};
	tempFormData = {};
	defaultShareProps = [];

	groupOptions = [];

	docClasses = [];
	shareDoc: number;
	shareDocs = [];
	searchDocs = [];

	shareFilter: string;
	shareSortCol = 'name';
	shareSortAsc = true;
	shareLinks: SharesLink[] = [];

	fileShareClass: any;

	objectTypeIcons = {};
	useMfilesIcons = true;

	shares = [];
	sharesLoaded = false;
	showExpiredShares = false;

	activeShare = -1;
	activeDoc = -1;

	updateShare = false;
	updateShareId = -1;

	deleteTarget: any;

	hasChanged = false;

	displayEmails = false;
	displayAddDocument = false;
	displayAddLink = false;

	singleLink = new SharesLink();
	formattedLink = new SharesLink();
	linkToDelete = {};
	linkToEdit = {};

	scopes = [];
	linkPermissions = [];
	orgs = [];
	groups = [];
	users = [];

	shareOrgs = {};
	shareGroups = {};

	selectedShareIndex = -1;
	selectedDocumentIndex = -1;
	selectedMemberIndex = -1;
	selectedFileIndex = 0;
	displayTab = 'viewer';
	displayingEmails = false;

	commentsEnabled = false;
	comments = [];
	commentsCount = 0;
	newComment = new CommentObject();

	coauthorEnabled = false;

	shareLinkEmailSubject: string;
	shareLinkEmailBody: string
	shareLinkEmailCC: string;

	vaultProperties = [];
	uneditableProps = [20, 21, 22, 23, 24, 25, 30, 31, 32, 40, 81, 89, 100, 101];
	docEditProps = [];
	optionLists = [];
	optionListTotal = 0;
	optionListLoaded = 0;

	propertyAliases = {};

	selectedDocs = [];
	allDocsSelected: boolean = false;

	viewerModalSettings = {
		displayViewer: true,
		displayMetadata: false,
		displayComments: false,
		displayWorkflow: false,
		disableAnnotations: true
	};

	shareLinkTarget: any;
	shareDocTarget: any;

	advancedSearchMode = 'filters';
	advancedSearchView = {
		startingPath: '', path: '', viewContents: undefined, sortColumn: '', sortAsc: true
	};
	advancedSearchShare: any;
	advancedSearchTargets = [];
	advancedSearchDisplayedFilter = '';
	advancedSearchDisplayedFilters = {};
	advancedSearchFilters = {};
	advancedSearchTerm = '';
	advancedSearchLoading = false;
	advancedSearchRan = false;
	advancedSearchResults = [];
	advancedSearchSortCol = 'title';
	advancedSearchSortAsc = true;

	mfilesUsers = [];

	editHeaders: boolean = false;
	changedHeaders = {};

	nameColspan = 1;

	defaultDateFormat: string;

	downloadProgress: number = 0;
	downloadSubscription: Subscription;
	docToDownload: any = { name: '', extension: '' };

	showDragDropBorder: boolean = false;

	uploadsCommitting: boolean = false;
	uploadProgressStats: any = {};
	microserviceUploadSubscription: Subscription;
	uploadProgressMessage: string = '';

	propertyDefIds: any;
	currentUserId: number;
	loadingDownloadSelected: boolean;
	loadingDownloadAll: boolean;

	constructor(
		private modalService: BsModalService,
		private mfilesService: MFilesService,
		private pageService: PageService,
		public configService: ConfigurationService,
		private domSanitizer: DomSanitizer,
		public authService: AuthService,
		private toastr: ToastrService,
		private layoutService: LayoutService
	) { }

	ngOnInit(): void {
		this.configService.list(false).subscribe((result) => {
			for (const config of result) {
				if (config.name === 'useMfilesIcons') {
					this.useMfilesIcons = config.value.toLowerCase() === 'true';
				} else if (config.name === 'commentsEnabled') {
					this.commentsEnabled = config.value.toLowerCase() === 'true';
				} else if (config.name === 'coauthorEnabled') {
					this.coauthorEnabled = config.value.toLowerCase() === 'true';
				} else if (config.name === 'shareLinkEmailSubject') {
					this.shareLinkEmailSubject = config.value;
				} else if (config.name === 'shareLinkEmailBody') {
					this.shareLinkEmailBody = config.value;
				} else if (config.name === 'shareLinkEmailCC') {
					this.shareLinkEmailCC = config.value;
				} else if (config.name === 'defaultDateFormat') {
					this.defaultDateFormat = config.value;
				}
			}

			if (this.useMfilesIcons) {
				this.getIcon(9);
			}
		});

		this.mfilesService.getObjectsByAlias(['TI.MConnect.Object.UserFileShares']).subscribe((objectAliasResult) => {
			this.mfilesService.getClassesByAlias(['TI.MConnect.Class.MConnectFileShare']).subscribe((classAliasResult) => {
				this.mfilesService.getPropertyDefsByAlias(['TI.MConnect.Property.MConnectFileShareLinks', 'TI.MConnect.Property.Organization', 'TI.MConnect.Property.Group', 'TI.MConnect.Property.Organizations', 'TI.MConnect.Property.Groups', 'TI.MConnect.Property.Documents', 'TI.MConnect.Property.MConnectFileShareOwner']).subscribe((propertyAliasResult) => {
					this.propertyAliases = propertyAliasResult.body;
					this.mfilesService.getClassProperties(classAliasResult.body['TI.MConnect.Class.MConnectFileShare']).subscribe((properties: any[]) => {
						this.fields = [];
						for (const prop of properties) {
							if (prop.id !== propertyAliasResult.body['TI.MConnect.Property.MConnectFileShareLinks'] && prop.id !== propertyAliasResult.body['TI.MConnect.Property.Documents'] && prop.id !== propertyAliasResult.body['TI.MConnect.Property.MConnectFileShareOwner']) {
								prop.property = prop.id;
								prop.propertyDef = prop.id;
								this.fields.push(prop);
							}
						}

						const optionListFields = [];
						for (const field of this.fields) {
							if ((field.dataType === 9 || field.dataType === 10) && field.propertyDef !== propertyAliasResult.body['TI.MConnect.Property.Organizations'] && field.propertyDef !== propertyAliasResult.body['TI.MConnect.Property.Groups']) {
								optionListFields.push(field);
							}
						}

						this.mfilesService.getOptionLists(optionListFields).subscribe((result) => {
							for (const propertyDef of Object.keys(result.body)) {
								this.optionLists[propertyDef] = result.body[propertyDef];


								if (this.optionLists[propertyDef].id === objectAliasResult.body['TI.MConnect.Object.UserFileShares']) {
									this.optionLists[propertyDef].mconnectUserField = true;
								}
							}
						});

						this.fileShareClass = classAliasResult.body['TI.MConnect.Class.MConnectFileShare'];
					});
				});
			});
		});

		this.loadScopeLists();

		this.mfilesService.getValueListsByAlias(['TI.MConnect.ValueList.Scopes', 'TI.MConnect.ValueList.MConnectFileShareLinkPermissions']).subscribe((valueListAliasResult) => {
			this.mfilesService.getValueListOptions(valueListAliasResult.body['TI.MConnect.ValueList.Scopes']).subscribe((scopeOptionsResult) => {
				this.scopes = scopeOptionsResult.body.items;
			});
			this.mfilesService.getValueListOptions(valueListAliasResult.body['TI.MConnect.ValueList.MConnectFileShareLinkPermissions']).subscribe((linkPermissionsResult) => {
				this.linkPermissions = linkPermissionsResult.body.items;
			});
		});

		this.mfilesService.getClasses(0).subscribe((result) => {
			this.docClasses = result;
		});

		this.mfilesService.getVaultProperties().subscribe((result) => {
			this.vaultProperties = result.body;
			for (const prop of this.vaultProperties) {
				if (prop.id === 25) { // ootb Created By prop
					this.mfilesService.getValueListOptions(prop.valueList).subscribe((usersResult) => {
						this.mfilesUsers = [];
						for (const user of usersResult.body.items) {
							if (user.id > -1) {
								this.mfilesUsers.push(user);
							}
						}
					});
				}
			}
		});

		this.mfilesService.getShareDefaults().subscribe((result: any[]) => {
			this.defaultShareProps = result;
		});

		if (this.authService.isAuthenticated()) {
			this.newComment.user = this.authService.getActiveUsername();
		}

		this.changedHeaders = { ... this.layoutService.getFileShareListingHeaders() };

		this.mfilesService.uploadProgressUpdated.subscribe((progressObj) => {
			this.uploadProgressStats = progressObj;
		});

		this.loadShares();
	}

	ngOnDestroy(): void {
		if (this.downloadSubscription) {
			this.downloadSubscription.unsubscribe();
		}
	}

	loadScopeLists() {
		this.mfilesService.getExternalShareScopeLists().subscribe((result: any) => {
			this.orgs = result.orgs;
			this.groups = result.groups;
			this.users = result.users;
			this.canCreate = result.canCreate;
			this.loadingCanCreate = false;
		});
	}

	loadShares() {
		this.loading = true;
		this.mfilesService.getExternalShares(this.showExpiredShares).subscribe((result: any[]) => {
			for (const share of result) {
				this.getIcon(share.type);
			}

			this.shares = result;
			this.shares.sort((a, b) => (a.name > b.name) ? 1 : -1);
			this.shares.forEach(share => ({ ...share, hasDocs: false, hasLinks: false }));
			this.sharesLoaded = true;
			this.loading = false;
			this.activeShare = -1;
			this.activeDoc = -1;
		});
		this.displayAddDocument = false;
		this.displayAddLink = false;
	}

	shareClicked(share: any, i: number) {
		this.searchDocs = [];
		this.displayAddDocument = false;
		this.displayAddLink = false;
		this.displayEmails = false;
		this.allDocsSelected = false;
		this.selectedDocs = [];
		if (this.activeShare == i) {
			this.activeShare = -1;
			this.activeDoc = -1;
		} else {
			if (!share.docs && !share.links) {
				this.loadingIndex = i;
				this.loadShareContents(share);
			}
			this.activeShare = i;
		}
	}

	loadShareContents(share: any) {
		this.shareOrgs[share.id] = undefined;
		this.shareGroups[share.id] = undefined;

		this.mfilesService.getExternalShareContents(share.id, share.expired).subscribe({
			next: (result) => {
				for (const link of result.links) {
					this.getIcon(link.type);
				}
				share.uploadClass = result.uploadClass;
				share.docs = result.docs;
				share.emails = result.emails;
				share.docs.sort((a, b) => (a.name > b.name) ? 1 : -1);
				share.links = this.sortShareLinks(result.links);
				share.hasDocs = result.docs.length !== 0;
				share.hasEmails = result.emails.length !== 0;
				share.hasLinks = result.links.length !== 0;
				share.permissions = result.permissions;
			},
			error: (err) => { },
			complete: () => {
				this.loadingIndex = -1;
				this.loading = false;
				this.allDocsSelected = false;
				this.selectedDocs = [];
			}
		});
	}

	sortShareLinks(links: any[]) {
		const anonLinks = [];
		const orgLinks = [];
		const groupLinks = [];
		const userLinks = [];
		const usersLinks = [];

		for (const link of links) {
			if (link.scope === 1) {
				anonLinks.push(link);
			} else if (link.scope === 2) {
				orgLinks.push(link);
			} else if (link.scope === 3) {
				groupLinks.push(link);
			} else if (link.scope === 4) {
				userLinks.push(link);
			} else if (link.scope === 5) {
				usersLinks.push(link);
			}
		}

		orgLinks.sort((a, b) => (a.orgName > b.orgName) ? 1 : -1);
		groupLinks.sort((a, b) => (a.groupName > b.groupName) ? 1 : -1);
		userLinks.sort((a, b) => (a.userName > b.userName) ? 1 : -1);
		usersLinks.sort((a, b) => (a.userNames > b.userNames) ? 1 : -1);

		const sortedLinks = [];
		sortedLinks.push.apply(sortedLinks, anonLinks);
		sortedLinks.push.apply(sortedLinks, orgLinks);
		sortedLinks.push.apply(sortedLinks, groupLinks);
		sortedLinks.push.apply(sortedLinks, userLinks);
		sortedLinks.push.apply(sortedLinks, usersLinks);
		return sortedLinks;
	}

	openModal(template: TemplateRef<any>, size: string) {
		this.modalRef = this.modalService.show(
			template,
			{ backdrop: 'static', class: 'modal-' + size, animated: false }
		);
	}

	openViewerModal(template: TemplateRef<any>, size: string) {
		this.displayTab = 'viewer';
		this.viewerModalRef = this.modalService.show(
			template,
			{ backdrop: 'static', class: 'modal-' + size, animated: false }
		);
	}

	openCreateShare() {
		if (!this.rightContainerExpanded) {
			this.formData = {};
			this.formData[100] = this.fileShareClass;
			for (const defaultProp of this.defaultShareProps) {
				for (const field of this.fields) {
					if (field.property === defaultProp.propertyDef) {
						if (field.dataType === 5 || field.dataType === 6 || field.dataType === 7) {
							const date = new Date();
							date.setDate(date.getDate() + parseInt(defaultProp.propertyValue.replace(/\D/g, ''), 10));
							this.formData[defaultProp.propertyDef] = date;
						} else if (field.dataType === 9) {
							this.formData[defaultProp.propertyDef] = parseInt(defaultProp.propertyValue, 10);
						} else if (field.dataType === 10) {
							this.formData[defaultProp.propertyDef] = [];
							for (const lookup of defaultProp.propertyValue.split(',')) {
								for (const option of this.getOptionListItems(defaultProp.propertyDef)) {
									if (parseInt(lookup, 10) === option.id) {
										this.formData[defaultProp.propertyDef].push({ name: option.name, id: option.id });
										break;
									}
								}
							}
						} else {
							this.formData[defaultProp.propertyDef] = defaultProp.propertyValue;
						}
					}
				}
			}

			this.rightContainerExpanded = true;
		} else {

			this.rightContainerExpanded = false;
		}
	}

	resetCreateShare() {
		this.formData = {};
		this.tempFormData = {};
		this.shareDoc = undefined;
		this.shareDocs = [];
		this.searchDocs = [];
		this.shareLinks = [];
		this.updateShare = false;
		this.displayEmails = false;
		this.displayAddDocument = false;
		this.displayAddLink = false;
		this.singleLink = new SharesLink();
		this.linkToDelete = {};
		this.linkToEdit = {};
		this.selectedDocs = [];
		this.allDocsSelected = false;
	}

	resetLink() {
		this.shareLinks = [];
		this.singleLink = new SharesLink();
		this.linkToDelete = {};
		this.linkToEdit = {};
	}

	resetAddDoc() {
		this.shareDoc = undefined;
		this.shareDocs = [];
		this.displayAddDocument = false;
	}

	inputChanged() {
		this.hasChanged = true;
	}

	selectFieldValueChanged(field: any) {
		const valueListForField = this.optionLists[field.property];

		for (const propertyDef of this.optionLists) {
			const childValueList = this.optionLists[propertyDef];

			if (childValueList && childValueList.hasOwner && childValueList.owner === valueListForField.id && this.optionLists[propertyDef].childItemsMap) {
				if (field.dataType === 9) {
					const ownerValue: number = this.formData[field.property];
					this.optionLists[propertyDef].items = this.optionLists[propertyDef].childItemsMap[ownerValue];
				} else if (field.dataType === 10) {
					const ownerValues: any[] = this.formData[field.property];
					this.optionLists[propertyDef].items = [];

					for (const ownerValue of ownerValues) {
						this.optionLists[propertyDef].items = this.optionLists[propertyDef].items.concat(this.optionLists[propertyDef].childItemsMap[ownerValue.id]);
					}
				}
			}
		}
		this.hasChanged = true;
	}

	multiselectChanged(field: any, event: any) {
		if (event) {
			let containsValue = false;

			if (!this.formData[field.property]) {
				this.formData[field.property] = [];
			} else {
				this.formData[field.property].forEach(value => {
					if (value.id === event.id) {
						containsValue = true;
					}
				});
			}

			if (!containsValue) {
				this.formData[field.property].push({ name: event.name, id: event.id });
			}
			this.hasChanged = true;
		}
	}

	checkAddUser(field: any, e: any) {
		if (this.optionLists[field.property] && this.optionLists[field.property].mconnectUserField && !e.id) {
			this.loading = true;
			this.mfilesService.registerEmail(e.name).subscribe((result) => {
				this.loadScopeLists();

				this.mfilesService.getOptionLists([field]).subscribe((optionResult) => {
					for (const propertyDef of Object.keys(this.optionLists)) {
						const optionList = this.optionLists[propertyDef];
						if (optionList.mconnectUserField) {
							optionList.items = optionResult.body[field.property].items;
						}
					}

					if (field.dataType === 9) {
						this.formData[field.property] = result.body;
					} else if (field.dataType === 10) {
						for (const option of this.formData[field.property]) {
							if (option.name === e.name) {
								option.id = result.body;
							}
						}
					}
					this.loading = false;
				});
			});
		}
	}

	checkAddUserScope(e: any) {
		if (e && !e.objVer) {
			this.loading = true;
			this.loadingCanCreate = true;
			this.mfilesService.registerEmail(e.title).subscribe((result) => {
				this.mfilesService.getExternalShareScopeLists().subscribe((scopeResult: any) => {
					this.users = scopeResult.users;
					this.loadingCanCreate = false;
					this.singleLink.user = result.body;
					this.loading = false;
				});
			});
		}
	}

	addUserToUsersScope(e: any, link: SharesLink) {
		if (e && e.objVer) {
			if (!link.users) {
				link.users = [];
			}
			if (link.users.indexOf(e.objVer.id) === -1) {
				link.users.push(e.objVer.id);
			}
		}
	}

	getUserName(id: number) {
		let name = '';

		for (const user of this.users) {
			if (user.objVer.id === id) {
				name = user.title;
				break;
			}
		}

		return name;
	}

	removeLinkUser(link: SharesLink, i: number) {
		link.users.splice(i, 1);
	}

	removeMultiselect(field: any, i: number) {
		this.formData[field.property].splice(i, 1);
		this.selectFieldValueChanged(field);
		if (this.propertyAliases["TI.MConnect.Property.Organizations"] === field.id && this.formData[this.propertyAliases["TI.MConnect.Property.Groups"]]) {
			const groups = this.getOptionListItems(this.propertyAliases["TI.MConnect.Property.Groups"]);
			for (let j = 0; j < this.formData[this.propertyAliases["TI.MConnect.Property.Groups"]].length; j++) {
				let validGroup = false;
				for (const group of groups) {
					if (group.id === this.formData[this.propertyAliases["TI.MConnect.Property.Groups"]][j].id) {
						validGroup = true;
						break;
					}
				}
				if (!validGroup) {
					this.formData[this.propertyAliases["TI.MConnect.Property.Groups"]].splice(j, 1);
					j = j - 1;
				}
			}
		}
		this.hasChanged = true;
	}

	shareDocChanged(event: any) {
		let containsValue = false;

		if (!this.shareDocs) {
			this.shareDocs = [];
		} else {
			this.shareDocs.forEach(value => {
				if (value.id === event.objVer.id) {
					containsValue = true;
				}
			});
		}

		if (!containsValue) {
			this.shareDocs.push({ title: event.title, id: event.objVer.id });
		}
		this.hasChanged = true;
	}

	shareDocSearch(event: any) {
		this.mfilesService.shareDocSearch(this.getSortedFilteredShares()[this.activeShare].id, event.term).subscribe((result: any) => {
			if (result) {
				this.searchDocs = result.items;
			} else {
				this.searchDocs = [];
			}
		});
	}

	removeShareDoc(i: number) {
		this.shareDocs.splice(i, 1);
	}

	createShare() {
		this.loadingRightPanel = true;

		const [properties, docs] = this.getPropsAndDocs();
		const shareInfo = {
			properties,
			docs,
			links: this.shareLinks,
			id: this.updateShareId
		}

		this.mfilesService.createUpdateExternalShare(shareInfo).subscribe((result) => {
			this.resetCreateShare();
			this.toastr.success('External Share Created');

			this.shares.push(result);
			this.shares.sort((a, b) => (a.name > b.name) ? 1 : -1);
			this.shares.forEach(share => ({ ...share, hasDocs: false, hasLinks: false }));
			this.sharesLoaded = true;
			this.loading = false;
			this.activeShare = -1;
			this.activeDoc = -1;

			this.rightContainerExpanded = false;

			this.loadingRightPanel = false;
		});
	}

	getPropsAndDocs() {
		const properties = [];
		let docs = '';

		for (const field of this.fields) {
			const property = new Property();
			property.id = field.id;
			property.dataType = field.dataType;

			if ((property.dataType === 5 || property.dataType === 6 || property.dataType === 7) && (!this.formData[field.id] || isNaN(this.formData[field.id].getTime()))) {
				this.formData[field.id] = '';
			}

			if (property.dataType === 10) {
				let value = '';
				if (this.formData[field.property]) {
					for (let i = 0; i < this.formData[field.property].length; i++) {
						value = value + this.formData[field.property][i].id + ',';
					}
					if (value !== '') {
						value = value.substring(0, value.length - 1);
					}
				}
				property.value = value;
			} else if (this.formData[field.id] === null || this.formData[field.id] === undefined) {
				property.value = '';
			} else {
				property.value = this.formData[field.id];
			}

			properties.push(property);
		}

		for (let i = 0; i < this.shareDocs.length; i++) {
			docs = docs + this.shareDocs[i].id + ',';
		}
		if (docs !== '') {
			docs = docs.substring(0, docs.length - 1);
		}
		return [properties, docs];
	}

	validForm() {
		let valid = true;

		const org = this.formData[this.propertyAliases['TI.MConnect.Property.Organizations']];
		const group = this.formData[this.propertyAliases['TI.MConnect.Property.Groups']];
		for (const field of this.fields) {
			if (field.required && !this.formData[field.property]) {
				valid = false;
				break;
			}
		}

		if (valid && !((org && org.length > 0) || (group && group.length > 0) || this.authService.isAdmin())) {
			valid = false;
		}

		return valid;
	}

	addLink() {
		this.shareLinks.push(new SharesLink());
	}

	removeLink(i: number) {
		this.shareLinks.splice(i, 1);
	}

	editFileShare(share: any) {
		this.searchDocs = [];
		this.rightContainerExpanded = true;
		if (!share.docs && !share.links) {
			this.loadingRightPanel = true;
			this.mfilesService.getExternalShareContents(share.id, share.expired).subscribe((result) => {
				share.docs = result.docs;
				share.docs.sort((a, b) => (a.name > b.name) ? 1 : -1);
				share.links = this.sortShareLinks(result.links);
				share.hasDocs = result.docs.length !== 0;
				share.hasLinks = result.links.length !== 0;
				share.permissions = result.permissions;
				this.loadingRightPanel = false;

				if (this.updateShare) {
					this.displayAddDocument = false;
					this.displayAddLink = false;
					this.setUpdateModal(share);
				} else {
					this.displayAddDocument = false;
					this.addSingleLink(share);
				}

			});
		} else {
			if (this.updateShare) {
				this.displayAddDocument = false;
				this.displayAddLink = false;
				this.setUpdateModal(share);
			} else {
				this.displayAddDocument = false;
				this.addSingleLink(share);
			}
		}
	}

	addFileToShare(share: any) {
		this.loading = true;
		this.mfilesService.addShareItem(share.id, this.shareDoc).subscribe((result) => {
			this.displayAddDocument = false;
			this.loadShareContents(share);
		});
	}

	addShareLink(share: any) {
		let canCreate = false;

		if (typeof this.singleLink.scope === 'string') {
			this.singleLink.scope = parseInt(this.singleLink.scope);
		}

		if (this.singleLink.scope === 1) {
			canCreate = true;
			this.singleLink.org = -1;
			this.singleLink.group = -1;
			this.singleLink.user = -1;
			this.singleLink.users = [];
		} else if (this.singleLink.scope === 2) {
			canCreate = this.singleLink.org !== -1;
			this.singleLink.group = -1;
			this.singleLink.user = -1;
			this.singleLink.users = [];
		} else if (this.singleLink.scope === 3) {
			canCreate = this.singleLink.group !== -1;
			this.singleLink.org = -1;
			this.singleLink.user = -1;
			this.singleLink.users = [];
		} else if (this.singleLink.scope === 4) {
			canCreate = this.singleLink.user !== -1;
			this.singleLink.org = -1;
			this.singleLink.group = -1;
			this.singleLink.users = [];
		} else if (this.singleLink.scope === 5) {
			canCreate = this.singleLink.user !== -1;
			this.singleLink.org = -1;
			this.singleLink.group = -1;
			this.singleLink.user = -1;
		}

		if (canCreate) {
			this.addSingleLink(share);
		}
	}

	setUpdateModal(share: any) {
		this.searchDocs = [];
		this.setShareData(share);
		this.hasChanged = false;
	}

	addSingleLink(share) {
		this.setShareData(share);
		const shareInfo = this.buildUpdateRequest();
		this.loading = true;
		this.mfilesService.createUpdateExternalShare(shareInfo).subscribe((result) => {
			this.resetCreateShare();
			this.toastr.success('Added Share Link to External Share');
			this.loadShareContents(share);
		});
	}

	updateFileShare() {
		const shareInfo = this.buildUpdateRequest();
		this.loadingRightPanel = true;
		this.mfilesService.createUpdateExternalShare(shareInfo).subscribe((result: any) => {
			this.resetCreateShare();
			this.toastr.success('External Share Updated');

			for (let i = 0; i < this.shares.length; i++) {
				if (this.shares[i].id === result.id) {
					this.shares.splice(i, 1);
				}
			}

			this.shares.push(result);
			this.shares.sort((a, b) => (a.name > b.name) ? 1 : -1);
			this.shares.forEach(share => ({ ...share, hasDocs: false, hasLinks: false }));
			this.sharesLoaded = true;
			this.loading = false;
			this.activeShare = -1;
			this.activeDoc = -1;

			this.loadingRightPanel = false;
			this.rightContainerExpanded = false;
		});
	}

	deleteSingleLink(share: any, linkIndex: number) {
		const linkId = share.links[linkIndex].id;
		share.links.splice(linkIndex, 1);
		this.loading = true;

		this.mfilesService.deleteShareLink(share.id, linkId).subscribe((result) => {
			this.linkToDelete = {};
			this.toastr.success('Deleted Share Link from External Share');
			this.loading = false;
		});
	}

	setLinkToEdit(link: any) {
		if (!link.checkedOut) {
			this.linkToEdit = link;
			this.setLinks(link);
			for (const shareLink of this.shareLinks) {
				if (shareLink.id === link.id) {
					this.formattedLink = shareLink;
					break;
				}
			}
			if (!this.formattedLink) {
				this.formattedLink = this.shareLinks[0];
			}
			this.shareLinks = [];
		}
	}

	editSingleLink(share, linkIndex) {
		share.links[linkIndex] = this.formattedLink;

		this.setShareData(share);

		const shareInfo = this.buildUpdateRequest();
		this.loading = true;

		this.mfilesService.createUpdateExternalShare(shareInfo).subscribe((result) => {
			this.toastr.success('Share Link Updated');
			this.loadShareContents(share);
			this.linkToEdit = {};
			this.formattedLink = new SharesLink();
		});
	}

	setShareData(share: any) {
		if (this.updateShare) {
			this.shareDocs = [];
			this.shareLinks = [];
		}
		if (share.id) {
			this.updateShareId = share.id;
		}
		if (this.displayAddLink) {
			this.shareLinks.push(this.singleLink);
		}
		for (const doc of share.docs) {
			this.shareDocs.push({
				title: doc.name + '.' + doc.extension,
				id: doc.id
			});
		}
		for (const link of share.links) {
			this.setLinks(link);
		}
		for (const prop of share.properties) {
			if (prop.value) {
				if (prop.value.dataType === 9) {
					this.formData[prop.propertyDef] = prop.value.lookup?.item;
				} else if (prop.value.dataType === 10) {
					const values = [];
					for (const lookup of prop.value.lookups) {
						values.push({ name: lookup.displayValue, id: lookup.item });
					}
					this.formData[prop.propertyDef] = values;
				} else if (prop.value.value && (prop.value.dataType === 5 || prop.value.dataType === 6 || prop.value.dataType === 7)) {
					this.formData[prop.propertyDef] = new Date(prop.value.value);
				} else {
					this.formData[prop.propertyDef] = prop.value.value;
				}
			}
		}
		this.formData[this.propertyAliases["TI.MConnect.Property.MConnectFileShareLinks"]] = [...share.links];
	}

	setLinks(link) {
		if (link.permissions) {
			const formattedLink = new SharesLink();
			formattedLink.id = link.id;
			formattedLink.name = link.name;
			formattedLink.scope = link.scope;
			formattedLink.org = link.org;
			formattedLink.group = link.group;
			formattedLink.user = link.user;

			if (link.permissions.indexOf(1) > -1) {
				formattedLink.annotate = true;
			}
			if (link.permissions.indexOf(2) > -1) {
				formattedLink.comment = true;
			}
			if (link.permissions.indexOf(3) > -1) {
				formattedLink.create = true;
			}
			if (link.permissions.indexOf(4) > -1) {
				formattedLink.delete = true;
			}
			if (link.permissions.indexOf(5) > -1) {
				formattedLink.download = true;
			}
			if (link.permissions.indexOf(6) > -1) {
				formattedLink.updateDocument = true;
			}
			if (link.permissions.indexOf(7) > -1) {
				formattedLink.updateMetadata = true;
			}
			if (link.permissions.indexOf(8) > -1) {
				formattedLink.view = true;
			}
			if (link.permissions.indexOf(9) > -1) {
				formattedLink.coauthor = true;
			}
			if (link.permissions.indexOf(10) > -1) {
				formattedLink.removeFromShare = true;
			}

			this.shareLinks.push(formattedLink);
		} else {
			this.shareLinks.push(link);
		}
	}

	buildUpdateRequest() {
		const [properties, docs] = this.getPropsAndDocs();
		const filteredProps = [...properties].filter(prop => prop.id !== 100);

		return {
			properties: filteredProps,
			docs,
			links: this.shareLinks,
			id: this.updateShareId
		}
	}

	openDeleteShare(share: any) {
		this.deleteTarget = share;
		this.openModal(this.fileShareDeleteModal, 'md');
	}

	deleteFileShare() {
		this.modalRef.hide();
		this.loading = true;
		this.mfilesService.deleteExternalShare(this.deleteTarget.id).subscribe(() => {
			this.activeShare = -1;
			for (let i = 0; i < this.shares.length; i++) {
				if (this.shares[i] === this.deleteTarget) {
					this.shares.splice(i, 1);
				}
			}
			this.loading = false;
			this.toastr.success('External Share Deleted');
		});
	}

	openShareLink(link: any) {
		window.open(link.url);
	}

	getLinkMailTo(link: any) {
		const linkParts = [];
		if (this.shareLinkEmailCC) {
			linkParts.push({ label: 'cc', value: this.shareLinkEmailCC });
		}
		if (this.shareLinkEmailSubject) {
			linkParts.push({ label: 'subject', value: this.shareLinkEmailSubject });
		}
		if (this.shareLinkEmailBody) {
			linkParts.push({ label: 'body', value: encodeURIComponent(this.shareLinkEmailBody.replace('[shareLink]', link.url)) });
		} else {
			linkParts.push({ label: 'body', value: link.url });
		}

		let href = '';
		if (linkParts.length > 0) {
			href = 'mailto:?';
			for (const part of linkParts) {
				if (part.label === 'body') {
					part.value = part.value + '%0A──────────────────────────────────────────%0ADo not modify anything below this line [FS:' + this.padLinkId(link.id) + ']';
				}
				href = href + part.label + '=' + part.value + '&';
			}
			href = href.substring(0, href.length - 1);
		}

		return href;
	}

	padLinkId(id: number) {
		let number = id + '';

		while (number.length < 6) {
			number = '0' + number;
		}

		return number;
	}

	copyShareLink(link: any, doc: any) {
		let url = link.url;
		if (doc) {
			url = url + '&id=' + doc.id + '&type=' + doc.type;
		}

		if (this.modalRef) {
			this.modalRef.hide();
		}

		navigator.clipboard.writeText(url);
		this.toastr.success('M-Connect Share URL saved to clipboard');
	}

	docClicked(doc: MFilesItem, shareIndex: number, documentIndex: number, memberIndex: number, fileIndex: number, isEmail: boolean) {
		if (doc.members || doc.files) {
			if (this.activeDoc === documentIndex) {
				this.activeDoc = -1;
			} else {
				this.activeDoc = documentIndex;
			}
		} else {
			this.fileClicked(doc, shareIndex, documentIndex, memberIndex, fileIndex, isEmail);
		}
	}

	fileClicked(obj: MFilesItem, shareIndex: number, documentIndex: number, memberIndex: number, fileIndex: number, isEmail: boolean) {
		this.displayingEmails = isEmail;
		if (shareIndex > -1) {
			this.selectedShareIndex = shareIndex;
		} else {
			this.selectedShareIndex = -1;
		}

		if (documentIndex > -1) {
			this.selectedDocumentIndex = documentIndex;
		} else {
			this.selectedDocumentIndex = -1;
		}
		this.selectedMemberIndex = memberIndex;
		this.selectedFileIndex = fileIndex;

		const context = {
			itemId: obj.members ? obj.members[memberIndex].id : obj.id,
			version: obj.version,
			type: 0,
			fileIndex: fileIndex
		};

		this.closeViewerModal();
		this.openViewerModal(this.viewerModal, 'xl tender');

		setTimeout(() => {
			this.pageService.documentSelectionOccurred.emit(context);
		}, 500);
	}

	prevFileClicked() {
		this.displayTab = 'viewer';
		let fileList = 'docs';
		if (this.displayingEmails) {
			fileList = 'emails';
		}
		let newDocumentIndex = this.selectedDocumentIndex;
		let newMemberIndex = this.selectedMemberIndex;
		let newFileIndex = this.selectedFileIndex;

		if (this.getSortedFilteredShares()[this.selectedShareIndex][fileList][this.selectedDocumentIndex].files && newFileIndex !== 0) {
			newFileIndex = newFileIndex - 1;
		} else if (this.getSortedFilteredShares()[this.selectedShareIndex][fileList][this.selectedDocumentIndex].members && newMemberIndex !== 0) {
			newMemberIndex = newMemberIndex - 1;
		} else {
			newDocumentIndex = newDocumentIndex - 1;
			if (this.getSortedFilteredShares()[this.selectedShareIndex][fileList][this.selectedDocumentIndex].members) {
				newMemberIndex = this.getSortedFilteredShares()[this.selectedShareIndex][fileList][this.selectedDocumentIndex].members.length - 1;
				newFileIndex = 0;
			} else if (this.getSortedFilteredShares()[this.selectedShareIndex][fileList][this.selectedDocumentIndex].files) {
				newMemberIndex = 0;
				newFileIndex = this.getSortedFilteredShares()[this.selectedShareIndex][fileList][this.selectedDocumentIndex].files.length - 1;
			}
		}

		this.fileClicked(this.getSortedFilteredShares()[this.selectedShareIndex][fileList][newDocumentIndex], this.selectedShareIndex, newDocumentIndex, newMemberIndex, newFileIndex, this.displayingEmails);
	}

	nextFileClicked() {
		this.displayTab = 'viewer';
		let fileList = 'docs';
		if (this.displayingEmails) {
			fileList = 'emails';
		}
		let newDocumentIndex = this.selectedDocumentIndex;
		let newMemberIndex = this.selectedMemberIndex;
		let newFileIndex = this.selectedFileIndex;

		if (this.getSortedFilteredShares()[this.selectedShareIndex][fileList][this.selectedDocumentIndex].files && newFileIndex + 1 < this.getSortedFilteredShares()[this.selectedShareIndex][fileList][this.selectedDocumentIndex].files.length) {
			newFileIndex = newFileIndex + 1;
		} else if (this.getSortedFilteredShares()[this.selectedShareIndex][fileList][this.selectedDocumentIndex].members && newMemberIndex + 1 < this.getSortedFilteredShares()[this.selectedShareIndex][fileList][this.selectedDocumentIndex].members.length) {
			newMemberIndex = newMemberIndex + 1;
		} else {
			newDocumentIndex = newDocumentIndex + 1;
			newMemberIndex = 0;
			newFileIndex = 0;
		}
		this.fileClicked(this.getSortedFilteredShares()[this.selectedShareIndex][fileList][newDocumentIndex], this.selectedShareIndex, newDocumentIndex, newMemberIndex, newFileIndex, this.displayingEmails);
	}

	loadViewer() {
		this.displayTab = 'viewer';
		if (this.displayingEmails) {
			this.fileClicked(this.getSortedFilteredShares()[this.selectedShareIndex].emails[this.selectedDocumentIndex], this.selectedShareIndex, this.selectedDocumentIndex, this.selectedMemberIndex, this.selectedFileIndex, true);
		} else {
			this.fileClicked(this.getSortedFilteredShares()[this.selectedShareIndex].docs[this.selectedDocumentIndex], this.selectedShareIndex, this.selectedDocumentIndex, this.selectedMemberIndex, this.selectedFileIndex, false);
		}
	}

	loadComments() {
		this.loadingComments = true;
		this.comments = [];
		this.displayTab = 'comments';

		let shareItem;
		if (this.displayingEmails) {
			shareItem = this.getSortedFilteredShares()[this.selectedShareIndex].emails[this.selectedDocumentIndex];
		} else {
			shareItem = this.getSortedFilteredShares()[this.selectedShareIndex].docs[this.selectedDocumentIndex];
		}
		if (shareItem.members) {
			shareItem = shareItem.members[this.selectedMemberIndex];
		}

		this.mfilesService.getComments(shareItem.id).subscribe((result) => {
			this.handleCommentsResponse(result);
		});
	}

	onCommentSubmit() {
		this.loadingComments = true;

		let shareItem;
		if (this.displayingEmails) {
			shareItem = this.getSortedFilteredShares()[this.selectedShareIndex].emails[this.selectedDocumentIndex];
		} else {
			shareItem = this.getSortedFilteredShares()[this.selectedShareIndex].docs[this.selectedDocumentIndex];
		}
		if (shareItem.members) {
			shareItem = shareItem.members[this.selectedMemberIndex];
		}

		this.mfilesService.postComment(shareItem.id, null, this.newComment).subscribe((result) => {
			this.clearCommentForm();
			this.handleCommentsResponse(result);
			this.toastr.success(`Comment successfully added.`);
		});
	}

	onNewComment(event: any) {
		this.loadingComments = true;

		this.mfilesService.postComment(event.id, event.parentComment, event).subscribe((result) => {
			this.handleCommentsResponse(result);
		});
	}

	handleCommentsResponse(result: any) {
		this.comments = result;
		this.setCommentsCount(this.comments);
		this.loadingComments = false;
	}

	setCommentsCount(comments: CommentObject[]) {
		this.commentsCount = 0;
		if (comments.length > 0) {
			this.commentsCount = comments[0].commentCount;
		}
	}

	clearCommentForm() {
		this.newComment.comment = '';
	}

	closeViewerModal() {
		if (this.viewerModalRef) {
			this.viewerModalRef.hide();
			this.viewerModalRef = null;
		}

		this.pageService.viewerModalClosed.emit();
	}

	closeModal() {
		if (this.modalRef) {
			this.modalRef.hide();
			this.modalRef = null;
		}
	}

	getIcon(type: number) {
		if (type !== 0 && this.useMfilesIcons && !this.objectTypeIcons[type]) {
			this.mfilesService.getObjectTypeIcon(type).subscribe((imageResult) => {
				if (imageResult.body && imageResult.body.size !== 0) {
					const reader = new FileReader();
					reader.onloadend = (e) => {
						this.objectTypeIcons[type] = this.domSanitizer.bypassSecurityTrustUrl(reader.result.toString());
					};
					reader.readAsDataURL(imageResult.body);
				} else {
					this.objectTypeIcons[type] = undefined;
				}
			});
		}
	}

	getShareScope(share: any) {
		let shareScope = '';

		for (const scope of this.scopes) {
			if (scope.id === share.scope || (typeof share.scope === 'string' && parseInt(share.scope, 10) === scope.id)) {
				shareScope = scope.name;
				break;
			}
		}

		return shareScope;
	}

	download(share: any, doc: any, fileIndex: number) {
		// If the document to download is larger than 50MB, open the download progress modal
		if (doc.size >= this.mfilesService.maxDownloadSize) {
			this.openModal(this.downloadProgressModal, 'md');
			this.docToDownload = doc;
		}

		this.downloadSubscription = this.mfilesService.downloadShareItem(share.id, doc.type, doc.id, fileIndex, doc.version, share.expired).subscribe(response => {
			if (response.type === 3) {
				this.downloadProgress = Math.floor(100 * (response.loaded / response.total));
			}
			if (response.type === 4 && response.body) {
				saveAs(response.body, response.headers.get('filename'));
				this.cancelDownload();
			}
		});
	}

	cancelDownload() {
		this.downloadSubscription.unsubscribe();
		this.closeModal();

		this.downloadProgress = 0;

		setTimeout(() => {
			this.docToDownload = null;
		}, 500);
	}

	removeFile(share: any, doc: any, docIndex: number) {
		this.loading = true;

		this.mfilesService.removeShareItem(share.id, doc.id, share.expired).subscribe((result) => {
			share.docs.splice(docIndex, 1);
			this.selectedDocs.splice(docIndex, 1);
			this.loading = false;
		});
	}

	reviseFile(share: any, file: any, fileIndex: number, e: any) {
		this.loading = true;

		const revisionFile: File = e.target.files[0];

		this.mfilesService.isMicroserviceAvailable().subscribe((available) => {
			if (available) {
				this.uploadProgressStats[revisionFile.name] = 0;	// Init the progress stats for this file
				this.mfilesService.microserviceUploadProgress = this.uploadProgressStats;
				this.openModal(this.uploadProgressModal, 'md');

				this.microserviceUploadSubscription = from([''])
					.pipe(
						tap(() => this.authService.isUploading = true),
						concatMap((props) => this.mfilesService.prepareShareItemRevision(share.id, file.id, fileIndex)),						// Makes the prepareUploadRevision calls in order and returns the result in order.
						mergeMap((result, index) => this.mfilesService.microserviceUpload(result, e.target.files[0], true)
							.catch(err => {																										// If an error occurs while the file is uploading to the microservice, this catches it and ensures the rest of the uploads don't get canceled.
								if (err.file) {
									this.uploadProgressStats[err.file.name] = 'ERROR';															// UI looks for this value and uses it to determine if the error message should be shown. Don't remove it.
								}
								return EMPTY;
							}), 3),																												// Starts uploading the files to the microservice. The 3 tells angular to limit the number of concurrent uploads to 3.
						mergeMap((result) => result, 1),																						// Intermediate step since microserviceUpload() returns a Promise with an Observable in it. This just returns the enclosed Observable.
						tap(() => {
							this.authService.isUploading = false;
							this.mfilesService.emitUploadProgress('all', 100);
						}))																														// The upload to M-Files is now 100% complete.
					.subscribe({
						next: (res) => { },
						error: (err) => { },
						complete: () => {
							this.loadShareContents(share);

							setTimeout(() => {
								this.closeModal();

								this.mfilesService.microserviceUploadProgress = {};
								this.uploadProgressStats = {};
							}, 1500);
						}
					});
			} else {
				this.mfilesService.reviseShareItem(share.id, file.id, fileIndex, e.target.files[0], share.expired).subscribe((result) => {
					this.loadShareContents(share);
				});
			}
		});
	}

	uploadFiles(share: any, event: any) {
		let files: File[] = [];
		if (Array.isArray(event)) {
			files = Array.from(event);
		} else if (event.target?.files) {
			files = Array.from(event.target.files);
		}

		if (files.length === 0) return;

		this.loading = true;

		this.mfilesService.cancelMicroserviceUpload.subscribe(() => {
			this.microserviceUploadSubscription.unsubscribe();
			if (event.target?.files) {
				event.target.value = '';	// Need this to fix a bug where the system file explorer doesn't open if the user tries to open it a second time
			} else if (Array.isArray(event)) {
				event = [];
			}
			this.loading = false;
		});

		this.showDragDropBorder = false;

		this.mfilesService.getClassProperties(this.getSortedFilteredShares()[this.activeShare].uploadClass).subscribe((uploadProperties: any[]) => {
			this.mfilesService.isMicroserviceAvailable().subscribe((available) => {
				if (available) {
					const uploadProps = [];
					let maxConcurrentUploads: number = 3;
					let filesUploading: number = 0;
					let totalFiles: number = files.length;

					for (let i = 0; i < files.length; i++) {
						const file: File = files[i];

						if (file.size > 0) {
							this.uploadProgressStats[file.name] = 0;	// Init the progress stats for this file while we're iterating through the files
						} else {
							this.uploadProgressStats[file.name] = 'EMPTY';
							files.splice(i, 1);		// If the file is empty, remove it and don't try to upload it. A message will be displayed to the user for this file.
							totalFiles--;
							i--;
							continue;
						}

						if (file.size >= (1024 * 1024 * 200)) { // 200MB
							maxConcurrentUploads = 1;
						}

						const props = [];
						for (const prop of uploadProperties) {
							const propCopy = JSON.parse(JSON.stringify(prop));
							if (propCopy.id === 0) {
								propCopy.value = this.getFileName(file.name);
							}
							props.push(propCopy);
						}
						uploadProps.push(props);
					}

					this.mfilesService.microserviceUploadProgress = this.uploadProgressStats;
					this.openModal(this.uploadProgressModal, 'md');

					this.microserviceUploadSubscription = from(uploadProps)
						.pipe(
							tap(() => this.authService.isUploading = true),
							concatMap((props) => this.mfilesService.prepareShareItemCheckin(share.id, props)),								// Makes the prepareShareItemCheckin calls in order and returns the result in order.
							mergeMap((result, index) => {
								filesUploading += 1;
								this.uploadProgressMessage = `Uploading ${filesUploading}/${totalFiles}`;

								return this.mfilesService.microserviceUpload(result, files[index])
									.catch(err => {																								// If an error occurs while the file is uploading to the microservice, this catches it and ensures the rest of the uploads don't get canceled.
										if (err.file) {
											this.uploadProgressStats[err.file.name] = 'ERROR';													// UI looks for this value and uses it to determine if the error message should be shown. Don't remove it.
										}
										return EMPTY;
									})
							}, maxConcurrentUploads),																										// Starts uploading the files to the microservice. The 3 tells angular to limit the number of concurrent uploads to 3.
							mergeMap((result) => result, 1),																				// Intermediate step since microserviceUpload() returns a Promise with an Observable in it. This just returns the enclosed Observable.
							toArray(),																										// Merge all of the microserviceUpload results into an array.
							tap(() => {
								this.uploadsCommitting = true;
								this.uploadProgressMessage = 'Finalizing';
							}),
							mergeMap((uploadResults) => this.mfilesService.postShareItemCheckinMultiple(share.id, uploadResults)			// Calls the postShareItemCheckinMultiple with all of the new objects in M-Files.
								.pipe(
									catchError(err => {
										this.toastr.error('An error occurred while attempting to upload your files into M-Files. Please try again later.');
										return EMPTY;
									})
								), 1),
							tap(() => {
								this.uploadsCommitting = false;
								this.authService.isUploading = false;
								this.mfilesService.emitUploadProgress('all', 100);
								this.uploadProgressMessage = 'Complete';
							}))								// The upload to M-Files is now 100% complete.
						.subscribe({
							next: (res) => { },
							error: (err) => { },
							complete: () => {
								this.loadShareContents(share);

								setTimeout(() => {
									this.closeModal();

									if (event.target?.files) {
										event.target.value = '';	// Need this to fix a bug where the system file explorer doesn't open if the user tries to open it a second time
									} else if (Array.isArray(event)) {
										event = [];
									}

									this.mfilesService.microserviceUploadProgress = {};
									this.uploadProgressStats = {};
									this.uploadProgressMessage = '';
								}, 1500);
							}
						});
				} else {
					const file = files[0];
					const newFiles = [...files].filter(uploadedFile => uploadedFile.name !== file.name);
					const props = [];

					for (let i = 0; i < files.length; i++) {
						const file: File = files[i];

						for (const prop of uploadProperties) {
							const propCopy = JSON.parse(JSON.stringify(prop));
							if (propCopy.id === 0) {
								propCopy.value = this.getFileName(file.name);
							}
							props.push(propCopy);
						}
					}

					this.mfilesService.checkinShareItem(share.id, props, file, share.expired).pipe(finalize(() => {
						if (newFiles.length) {
							this.uploadFiles(share, newFiles);
						} else {
							this.loadShareContents(share);
						}
					})).subscribe();
				}
			});
		});
	}

	cancelUpload() {
		this.mfilesService.cancelMicroserviceUpload.next(null);
		this.mfilesService.microserviceUploadProgress = {};
		this.uploadProgressStats = {};
		this.uploadProgressMessage = '';
		this.closeModal();
	}

	getFileName(fileName: string): string {
		const parts = fileName.split('.');
		parts.pop();
		return parts.join('.');
	}

	loadDocProperties() {
		this.loadingProperties = true;
		this.docEditProps = [];
		this.displayTab = 'properties';

		let shareItem;
		if (this.displayingEmails) {
			shareItem = this.getSortedFilteredShares()[this.selectedShareIndex].emails[this.selectedDocumentIndex];
		} else {
			shareItem = this.getSortedFilteredShares()[this.selectedShareIndex].docs[this.selectedDocumentIndex];
		}
		if (shareItem.members) {
			shareItem = shareItem.members[this.selectedMemberIndex];
		}

		this.mfilesService.getShareItemProperties(this.getSortedFilteredShares()[this.selectedShareIndex].id, 0, shareItem.id, shareItem.version).subscribe((result) => {
			const responseBody: any = result.body;
			for (const prop of responseBody.properties) {
				if (this.uneditableProps.indexOf(prop.propertyDef) === -1) {
					const editProp = {
						name: prop.name,
						id: prop.propertyDef,
						dataType: prop.value.dataType,
						value: prop.value.value,
						displayValue: prop.value.displayValue
					};
					if (editProp.dataType === 5 || editProp.dataType === 6 || editProp.dataType === 7) {
						editProp.value = new Date(prop.value.value);
					} else if (editProp.dataType === 9) {
						this.getOptionList(editProp.id);
						editProp.value = prop.value.lookup.item;
					} else if (editProp.dataType === 10) {
						this.getOptionList(editProp.id);
						editProp.value = [];
						for (const lookup of prop.value.lookups) {
							editProp.value.push({
								value: lookup.item,
								name: lookup.displayValue
							});
						}
					}
					this.docEditProps.push(editProp);
				}
			}
			if (this.optionListTotal === this.optionListLoaded) {
				this.loadingProperties = false;
			}
		});
	}

	getOptionList(propertyDef: number) {
		if (!this.optionLists[propertyDef]) {
			this.loadingProperties = true;
			this.optionLists[propertyDef] = [];
			this.optionListTotal = this.optionListTotal + 1;
			for (const prop of this.vaultProperties) {
				if (prop.id === propertyDef) {
					this.mfilesService.getValueListOptions(prop.valueList).subscribe((result) => {
						this.optionLists[propertyDef] = result.body;
						this.optionListLoaded = this.optionListLoaded + 1;
						if (this.optionListTotal === this.optionListLoaded) {
							this.loadingProperties = false;
						}
					});
					break;
				}
			}
		}
	}

	editMultiselectChanged(i: number, event: any) {
		let containsValue = false;

		if (!this.docEditProps[i].value) {
			this.docEditProps[i].value = [];
		} else {
			for (const value of this.docEditProps[i].value) {
				if (value.id === event.id) {
					containsValue = true;
				}
			}
		}

		if (!containsValue) {
			this.docEditProps[i].value.push({ value: event.id, name: event.name });
		}
	}

	removeEditMultiselectOption(prop: any, optionIndex: number) {
		prop.value.splice(optionIndex, 1);
	}

	removeProp(i: number) {
		this.docEditProps.splice(i, 1);
	}

	saveProperties() {
		this.loadingProperties = true;
		const submitProps = [];

		for (const prop of this.docEditProps) {
			let value = prop.value;
			if (prop.dataType === 10) {
				value = '';
				for (const option of prop.value) {
					value = value + option.value + ',';
				}
				if (value.length > 0) {
					value = value.substring(0, value.length - 1);
				}
			} else if (prop.dataType === 5 || prop.dataType === 6 || prop.dataType === 7) {
				value = new Date(value);
			}

			submitProps.push({ id: prop.id, dataType: prop.dataType, value: value });
		}

		let itemId = -1;
		if (this.displayingEmails) {
			itemId = this.getSortedFilteredShares()[this.selectedShareIndex].emails[this.selectedDocumentIndex].id;
		} else {
			itemId = this.getSortedFilteredShares()[this.selectedShareIndex].docs[this.selectedDocumentIndex].id;
		}

		this.mfilesService.updateObject(0, itemId, submitProps).subscribe((result) => {
			this.toastr.success('Successfully updated document properties');
			this.closeViewerModal();
			this.loadingProperties = false;
		});
	}

	getLinkName(link: any) {
		let name = '';
		if (link.scope === 1) {
			name = link.scopeName;
		} else if (link.scope === 2) {
			name = link.scopeName + ' - ' + link.orgName;
		} else if (link.scope === 3) {
			name = link.scopeName + ' - ' + link.groupName;
		} else if (link.scope === 4) {
			name = link.scopeName + ' - ' + link.userName;
		} else if (link.scope === 5) {
			if (link.users.length > 1) {
				name = link.scopeName + ' - Multiple Selected';
			} else {
				name = link.scopeName + ' - ' + link.userNames;
			}
		}
		return name;
	}

	getOptionListItems(propertyDef: number) {
		let options = [];

		if (propertyDef === this.propertyAliases["TI.MConnect.Property.Organizations"]) {
			options = this.orgs;
		} else if (propertyDef === this.propertyAliases["TI.MConnect.Property.Groups"]) {
			const newOptions = [];
			for (const group of this.groups) {
				if (this.formData[this.propertyAliases["TI.MConnect.Property.Organizations"]]) {
					for (const org of this.formData[this.propertyAliases["TI.MConnect.Property.Organizations"]]) {
						if (org.id === group.parent) {
							newOptions.push(group);
						}
					}
				}
			}
			if (JSON.stringify(this.groupOptions) !== JSON.stringify(newOptions)) {
				this.groupOptions = newOptions;
			}
			options = this.groupOptions;
		} else if (this.optionLists[propertyDef] && this.optionLists[propertyDef].items) {
			options = this.optionLists[propertyDef].items;
		}

		return options;
	}

	getSortedFilteredShares() {
		const shareList = [];

		for (const share of this.shares) {
			if (this.shareFilter) {
				if (share.name.toLowerCase().indexOf(this.shareFilter.toLowerCase()) > -1) {
					shareList.push(share);
				}
			} else {
				shareList.push(share);
			}
		}

		if (this.shareSortAsc) {
			shareList.sort((a, b) => (a[this.shareSortCol] > b[this.shareSortCol]) ? 1 : -1);
		} else {
			shareList.sort((a, b) => (a[this.shareSortCol] < b[this.shareSortCol]) ? 1 : -1);
		}

		return shareList;
	}

	updateSort(col: string) {
		this.activeShare = -1;
		if (this.shareSortCol === col) {
			this.shareSortAsc = !this.shareSortAsc;
		} else {
			this.shareSortCol = col;
			this.shareSortAsc = true;
		}
	}

	isFirstDoc() {
		return this.selectedDocumentIndex === 0 && this.selectedMemberIndex === 0 && this.selectedFileIndex === 0;
	}

	isLastDoc() {
		let itemList = 'docs';
		if (this.displayingEmails) {
			itemList = 'emails';
		}
		return this.selectedDocumentIndex == (this.getSortedFilteredShares()[this.selectedShareIndex][itemList].length - 1) && (!this.getSortedFilteredShares()[this.selectedShareIndex][itemList][this.selectedDocumentIndex].members || this.getSortedFilteredShares()[this.selectedShareIndex][itemList][this.selectedDocumentIndex].members.length === this.selectedMemberIndex + 1) && (!this.getSortedFilteredShares()[this.selectedShareIndex][itemList][this.selectedDocumentIndex].files || this.getSortedFilteredShares()[this.selectedShareIndex][itemList][this.selectedDocumentIndex].files.length === this.selectedFileIndex + 1);
	}

	getScopeableOrgs(share: any) {
		if (!this.shareOrgs[share.id]) {
			const shareOrgs = [];
			for (const org of this.orgs) {
				if (share.orgIds.indexOf(org.id) > -1) {
					shareOrgs.push(org);
				}
			}
			this.shareOrgs[share.id] = shareOrgs;
		}
		return this.shareOrgs[share.id];
	}

	getScopeableGroups(share: any) {
		if (!this.shareGroups[share.id]) {
			const shareGroups = [];
			for (const group of this.groups) {
				if (share.groupIds.indexOf(group.id) > -1) {
					shareGroups.push(group);
				}
			}
			this.shareGroups[share.id] = shareGroups;
		}
		return this.shareGroups[share.id];
	}

	openShareLinkModal(share: any, doc: any) {
		this.shareLinkTarget = share;
		this.shareDocTarget = doc;
		this.openModal(this.docShareModalModal, 'lg');
	}

	hasEditableMultiSelect() {
		let atLeastOne = false;

		for (const prop of this.docEditProps) {
			if (prop.editable && prop.dataType === 10) {
				atLeastOne = true;
				break;
			}
		}

		return atLeastOne;
	}

	checkAll(shareDocs: any[], event: any) {
		for (const doc of shareDocs) {
			doc.checkedForDownload = event.target.checked;
		}
	}

	docIsChecked(doc: any): boolean {
		return this.selectedDocs.indexOf(doc) > -1;
	}

	dowloadFiles(share: any): void {
		if (this.selectedDocs.length > 1) {
			this.mfilesService.downloadMultiple(this.selectedDocs).subscribe(response => {
				if (response.body) {
					saveAs(response.body, `${share.name}_selected_documents.zip`);
					this.selectedDocs = [];
					this.allDocsSelected = false;
				}
			});
		} else {
			this.download(share, this.selectedDocs[0], 0);
			this.selectedDocs = [];
		}
	}

	docChecked(doc: any, event: any) {
		doc.checkedForDownload = event.target.checked;
	}

	downloadSelected(shareDocs: any[]) {
		this.loadingDownloadSelected = true;
		const docsToDownload: any[] = [];
		for (const doc of shareDocs) {
			doc.downloading = false;
			doc.percentDownloaded = 0;
			doc.cancelDownloadSubject = new Subject<boolean>();
			if (doc.checkedForDownload) {
				docsToDownload.push(doc);
			}
		}
		if (docsToDownload.length === 0) {
			this.toastr.info('Please select one or more documents to download.');
			this.loadingDownloadSelected = false;
		} else if (docsToDownload.length === 1) {
			this.downloadReportProgress(docsToDownload[0]);
			this.loadingDownloadSelected = false;
		} else if (docsToDownload.length > 1) {
			this.downloadMultipleReportProgress(docsToDownload);
			this.loadingDownloadSelected = false;
		}
	}

	atLeastOneDocChecked(shareDocs: any[]) {
		let isOneDocChecked = false;
		for (const doc of shareDocs) {
			if (doc.checkedForDownload) {
				isOneDocChecked = true;
				break;
			}
		}
		return isOneDocChecked;
	}

	downloadAll(shareDocs: any[]) {
		this.loadingDownloadAll = true;
		for (const doc of shareDocs) {
			doc.downloading = false;
			doc.percentDownloaded = 0;
			doc.cancelDownloadSubject = new Subject<boolean>();
		}
		this.downloadMultipleReportProgress(shareDocs);
		this.loadingDownloadAll = false;
	}

	downloadReportProgress(doc: any) {
		doc.downloading = true;

		this.mfilesService.downloadReportProgress(doc.type, doc.id, doc.version, 0).pipe(
			takeUntil(doc.cancelDownloadSubject)
		).subscribe({
			next: (event) => {
				if (event.type === HttpEventType.DownloadProgress) {
					const percentDownloaded: number = (event.loaded / event.total) * 100;
					doc.percentDownloaded = percentDownloaded;
				}
				if (event.type === HttpEventType.Response) {
					saveAs(event.body, event.headers.get('filename'));
				}
			},
			error: (err) => {
				this.toastr.error('An error occurred while downloading ' + doc.title + '. Please try again later.');
				console.error(err);
			},
			complete: () => {
				doc.downloading = false;
				doc.percentDownloaded = 0;
			}
		});
	}

	downloadMultipleReportProgress(docs: any[]) {
		const docsCopy = [...docs];
		this.sortByFileSize(docsCopy);

		const observables: Observable<HttpEvent<Blob>>[] = [];
		docsCopy.forEach((doc) => {
			docs.find(item => item.id === doc.id).downloading = true;
			observables.push(this.mfilesService.downloadReportProgress(doc.type, doc.id, doc.version, 0));
		});
		const subscriptions = from(observables).pipe(
			mergeMap((observable, i) => {
				return observable.pipe(
					takeUntil(docs.find(item => item.id === docsCopy[i].id).cancelDownloadSubject),
					map((event) => [event, docsCopy[i].id]),
					catchError((err) => {
						console.error(err);
						this.toastr.error('An error occurred while downloading ' + docsCopy[i].title + '. Please try again later.');
						return err;
					})
				);
			}, 3)
		).subscribe({
			next: ([event, id]: [HttpEvent<Blob>, number]) => {
				const doc: MFilesItem = docs.find(doc => doc.id === id);

				if (event.type === HttpEventType.DownloadProgress) {
					const percentDownloaded: number = (event.loaded / event.total) * 100;
					doc.percentDownloaded = percentDownloaded;
				}
				if (event.type === HttpEventType.Response) {
					saveAs(event.body, event.headers.get('filename'));
					doc.downloading = false;
					doc.percentDownloaded = 0;
				}
			},
			error: (err) => {
				console.error(err);
			},
			complete: () => {
				console.log(subscriptions);
			}
		});
	}

	sortByFileSize(docs: MFilesItem[]) {
		docs.sort((a, b) => {
			if (a !== null && a !== undefined && b !== null && b !== undefined) {
				if (a.files?.length === 1 && b.files?.length === 1) {
					return a.files[0].size - b.files[0].size;
				}
			}

			return 0;
		})
	}

	openAdvancedSearch(share: any) {
		this.advancedSearchMode = 'filters';
		this.resetAdvancedSearch(share);
		this.openModal(this.advancedSearchModal, 'xl');
	}

	changeAdvancedSearchMode(mode: string) {
		this.advancedSearchMode = mode;
		this.resetAdvancedSearch(this.advancedSearchShare);
	}

	resetAdvancedSearch(share: any) {
		this.advancedSearchView.path = this.advancedSearchView.startingPath;
		this.advancedSearchShare = share;
		this.advancedSearchTargets = [];
		this.advancedSearchDisplayedFilter = '';
		this.advancedSearchDisplayedFilters = {};
		this.advancedSearchFilters = {};
		this.advancedSearchTerm = '';
		this.advancedSearchRan = false;
		this.advancedSearchResults = [];
	}

	addRemoveAdvancedSearchTarget(item: any, e: any) {
		if (item.objVer) {
			item.id = item.objVer.id;
		}

		if (e.target.checked) {
			this.advancedSearchTargets.push(item.id);
		} else {
			this.advancedSearchTargets.splice(this.advancedSearchTargets.indexOf(item.id), 1);
		}
	}

	addToAdvancedSearchShare() {
		this.modalRef.hide();
		this.loading = true;

		this.mfilesService.addShareItems(this.advancedSearchShare.id, this.advancedSearchTargets).subscribe(() => {
			this.displayAddDocument = false;
			this.loadShareContents(this.advancedSearchShare);
		});
	}

	performAdvancedSearch() {
		this.advancedSearchLoading = true;
		const filters = [];
		for (const propId of Object.keys(this.advancedSearchFilters)) {
			if (this.advancedSearchFilters[propId]) {
				if (propId.indexOf('gt') > -1) {
					filters.push({
						id: propId.substring(0, propId.indexOf('gt')),
						value: this.advancedSearchFilters[propId],
						gt: true
					});
				} else if (propId.indexOf('lt') > -1) {
					filters.push({
						id: propId.substring(0, propId.indexOf('lt')),
						value: this.advancedSearchFilters[propId],
						lt: true
					});
				} else {
					filters.push({
						id: propId,
						value: this.advancedSearchFilters[propId]
					});
				}
			}
		}

		this.mfilesService.shareAdvancedSearch(filters, this.advancedSearchShare.id, this.advancedSearchTerm).subscribe((result: any) => {
			this.advancedSearchRan = true;
			this.advancedSearchResults = result.items;
			for (const searchItem of this.advancedSearchResults) {
				if (searchItem.files.length > 0) {
					searchItem.extension = searchItem.files[0].extension;
				}
				searchItem.created = new Date(searchItem.created);
				searchItem.lastModified = new Date(searchItem.lastModified);
			}
			this.advancedSearchLoading = false;
		});
	}

	getSortedAdvancedSearchResults() {
		const items = [];

		for (const share of this.advancedSearchResults) {
			items.push(share);
		}

		if (this.advancedSearchSortAsc) {
			items.sort((a, b) => (a[this.advancedSearchSortCol] > b[this.advancedSearchSortCol]) ? 1 : -1);
		} else {
			items.sort((a, b) => (a[this.advancedSearchSortCol] < b[this.advancedSearchSortCol]) ? 1 : -1);
		}

		return items;
	}

	updateSearchSort(col: string) {
		if (this.advancedSearchSortCol === col) {
			this.advancedSearchSortAsc = !this.advancedSearchSortAsc;
		} else {
			this.advancedSearchSortCol = col;
			this.advancedSearchSortAsc = true;
		}
	}

	advancedSearchFilterAdded(e: any) {
		if (e) {
			this.advancedSearchDisplayedFilters[e] = true;
		}
		this.advancedSearchDisplayedFilter = '';
	}

	advancedSearchFilterRemoved(e: any, filter: any) {
		this.advancedSearchDisplayedFilters[e] = false;
		this.advancedSearchFilters[filter] = undefined;
		if (filter === -1) {
			this.advancedSearchTerm = '';
		}
	}

	getFormattedHeaders(index: number): string {
		const formattedHeaders = ['Owner', 'Organizations', 'Groups', 'Expiration Date'];
		return formattedHeaders[index];
	}

	getHeaderKeys(): string[] {
		return Object.keys(this.layoutService.getFileShareListingHeaders());
	}

	changeHeader(headerKey: string, checked: boolean) {
		this.changedHeaders[headerKey] = checked;
	}

	saveHeaderChanges() {
		this.layoutService.setFileShareListingHeaders(this.changedHeaders);
		this.setNameColspan();
		this.editHeaders = false;
	}

	setNameColspan() {
		this.nameColspan = 1;
		let count = 0;
		for (const headerKey of Object.keys(this.layoutService.getFileShareListingHeaders())) {
			if (!this.changedHeaders[headerKey]) {
				count++;
			}
		}
		this.nameColspan += count;
	}

	getPermissionsName(id: number) {
		let name = '';

		for (const permission of this.linkPermissions) {
			if (permission.id === id) {
				name = permission.name;
				break;
			}
		}

		return name;
	}

	getScopeName(id: number) {
		let name = '';

		for (const scope of this.scopes) {
			if (scope.id === id) {
				name = scope.name
			}
		}

		return name;
	}
}